/**
 * Removes duplicates from an array
 * @param arr - array with potential duplicates to remove
 * @returns array with duplicates removed, in the order they first appeared
 */
export default function uniq<T>(arr: T[]): T[] {
  return [...new Set(arr)]
}
